<template>
  <ul class="navigation" :class="orientation">
    <li v-for="item in items" :key="item.name">
      <BaseAction v-slot="{ actionAttrs, handleClick }" v-bind="item.action"> 
        <a v-bind="actionAttrs"
          @click="handleClick">
            {{item.title}}
        </a>
      </BaseAction> 
    </li>
  </ul>
</template>

<script>

import BaseButton from '../BaseButton/BaseButton'

export default {
  components: {
    BaseButton
  },
  props: {
    orientation: {
      default: 'horizontal'
    },
    items: {
      type: Array,
      default:() => ({})
    }
  }
}
</script>

<style lang="scss">
.navigation.horizontal {
  display: flex;
  justify-content: center;
  align-items: center;

  li {
    margin-right: 0.9em;
    &:last-child {
      margin-right: 0px;
    }
  }
}

.navigation.vertical {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 20px;

  li {
    margin-bottom: 1em;
    &:last-child {
      margin-right: 0px;
    }
  }
}

</style>